
define('modules/application/wizard/classes/automationRemoteControls',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./genericElement"

  ],

  function(app, Backbone, genericElement) {
    //Declaring views
    var _genericView = Backbone.View.extend({
      events: {
        "click .radio": "updateAbilitation",
        "change #webServerAccessory": "softwareChangedEventHandler"
      },

      serialize: function() {
        return {
          model: this.model,
          app: app
        };
      },

      initialize: function() {
        window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.accessoryLineChosenEventHandler, this);
        this.model.bind("packages:fetched", this.packagesFetchedEventHandler, this);
        this.model.bind("render:requested", this.render, this);
      },

      softwareChangedEventHandler: function(e) {
        this.model.changeSoftware(e.target.value);
      },

      updateAbilitation: function() {
        var selectedElementValue = this.$el.find("input[name='" + this.model.get("stringIdentifier") + "Status']:checked").val();

        if (selectedElementValue === "true")
          this.model.set("enabled", true);
        else
          this.model.set("enabled", false);

        this.render();
      },

      packagesFetchedEventHandler: function() {
        this.$el.find(".loadingSection").hide();
        this.$el.find(".regularSection").show();
        this.render();
      },

      showLoader: function() {
        this.$el.find(".regularSection").hide();
        this.$el.find(".loadingSection").show();
      },

      accessoryLineChosenEventHandler: function() {
        this.showLoader();
        this.model.fetchPackages();
      },

      afterRender: function() {
        this.$el.find("input").removeAttr("rel");
        this.$el.find(".radio").remove();
        window.customizeFormElements.call();
      }
    });

    var _webServerView = _genericView.extend({
      template: "application/wizard/sections/automationRemoteControls/webServer"
    });

    //Declaring models
    var _genericModel = Backbone.Model.extend({

      initialize: function() {
        this.bind("change:enabled", this.enabledChangeEventHandler, this);

        var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

        if (accessoryLineId && accessoryLineId !== 0)
          this.fetchPackages();
      },

      enabledChangeEventHandler: function() {
        this.get("eventAggregator").trigger("updateViews");
      },

      getProducts: function(originalPackage, confirmCondition) {
        var that = this;
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(originalPackage.packageClassId, function(data) {
          var mainProduct = _.filter(data.products, function(product) {
            return (product.mnemonic === 1);
          })[0];
          var secondaryProducts = _.filter(data.products, function(product) {
            return (product.mnemonic !== 1);
          });

          _.extend(originalPackage, mainProduct);
          originalPackage.secondaryProducts = secondaryProducts;

          if (confirmCondition !== undefined) confirmCondition();
          that.checkRaceCondition();
        }, true);
      },

      //Data products retrieval
      retrieveProductData: function(data, confirmCondition) {
        var that = this,
          fetchedPackages = data.packages,
          fetchedPackagesLength = fetchedPackages.length;
        for (i = 0; i < fetchedPackagesLength; i++) {
          if (fetchedPackages[i].specialVars && fetchedPackages[i].specialVars !== "" && typeof(fetchedPackages[i].specialVars) !== "object")
            fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);

          that.getProducts(fetchedPackages[i], confirmCondition);
        }
        return fetchedPackages;
      }
    });

    var _webServerModel = _genericModel.extend({
      defaults: {
        enabled: false,
        webServerDataFetchCompleted: false,
        softwareDataFetchCompleted: false,
        stringIdentifier: "webServer"
      },

      changeSoftware: function(packageClassId) {
        var fetchedSoftwares = this.get("fetchedSoftwares"),
          choosenAccessory = _.filter(fetchedSoftwares, function(iterableAccessory) {
            return iterableAccessory.packageClassId === packageClassId;
          })[0];

        this.set("accessory", choosenAccessory);
        this.trigger("render:requested");
      },

      //Race condition check
      checkRaceCondition: function() {
        if (this.get("webServerDataFetchCompleted") && this.get("softwareDataFetchCompleted"))
          this.trigger("packages:fetched");
      },

      //Defining success callbacks
      webServerPackageFetchSuccessCallback: function(data) {
        var that = this;
        that.attributes.fetchedPackages = that.retrieveProductData(data, function() {
          that.set("webServerDataFetchCompleted", true);
          if (!that.get("packageClassId"))
            _.extend(that.attributes, that.get("fetchedPackages")[0]);
          else
            _.extend(that.attributes, _.filter(that.get("fetchedPackages"), function(iterablePackage) {
              return iterablePackage.packageClassId === that.get("packageClassId");
            })[0]);

          that.trigger("render:requested");
        });
      },

      //Defining success callbacks
      softwarePackageFetchSuccessCallback: function(data) {
        var that = this;
        that.attributes.fetchedSoftwares = that.retrieveProductData(data, function() {
          that.set("softwareDataFetchCompleted", true);
          if ((!that.get("software")) || (!that.get("software").packageClassId))
            that.attributes.software = that.get("fetchedSoftwares")[0];
          else
            _.extend(that.attributes.software, _.filter(that.get("fetchedSoftwares"), function(iterablePackage) {
              return iterablePackage.packageClassId === that.get("software").packageClassId;
            })[0]);

        });
      },
      softwarePackageFetchErrorCallback: function(){
          that.set("softwareDataFetchCompleted", true);
      },
      webServerPackageFetchErrorCallback: function(){
          that.set("webServerDataFetchCompleted", true);
      },

      fetchPackages: function() {
        var that = this,
          i = 0;

        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(810, function(data) {
          that.webServerPackageFetchSuccessCallback.apply(that, [data]);
        }, that.webServerPackageFetchErrorCallback);
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(816, function(data) {
          that.softwarePackageFetchSuccessCallback.apply(that, [data]);
        }, that.softwarePackageFetchErrorCallback);
      }
    });

    //Declaring main module
    var automationRemoteControls = _.extend({}, genericElement, {

      Views: {

        titleBar: genericElement.Views.titleBar.extend({

          template: "application/wizard/sections/automationRemoteControls/titleBar",
          tagName: "h3",

          initialize: function() {

            this.model.unbind("updateViews", this.setLabel);
            this.model.bind("updateViews", this.setLabel, this);

            this.model.set("titleBarView", this);
          },

          setLabel: function() {
            var labelContent = "",
              caption = this.$el.find(".caption"),
              webServerModel = this.model.get("webServerModel");

            if (webServerModel.get("enabled"))
              labelContent += $.i18n._("IDS_WAM2_810") + " - ";

            if (labelContent.endsWith(" - "))
              labelContent = labelContent.substring(0, labelContent.length - 3);

            if ((labelContent) && (labelContent !== "")) {
              if (caption.is(".hidden"))
                caption.hide(0, function() {
                  $(this).removeClass("hidden");
                  caption.html(labelContent);
                  caption.fadeIn(200);
                });
              else
                caption.html(labelContent);
            } else
            if (!caption.is(".hidden"))
              caption.fadeOut(200, function() {
                $(this).addClass("hidden");
              });
          }
        }),

        content: genericElement.Views.content.extend({
          className: "automationRemoteControls",
          events: {
            "click .radio": "typeSelectorChangedEventHandler"
          },

          serialize: function() {
            return genericElement.Views.content.prototype.serialize.apply(this);
          },

          initialize: function() {
            genericElement.Views.content.prototype.initialize.apply(this);

            this.webServerView = new _webServerView({
              model: this.model.get("webServerModel")
            });
          },

          beforeRender: function() {
            this.insertView(this.webServerView);
          }
        })
      },

      Model: genericElement.Model.extend({
        initialize: function() {
          this.set("eventAggregator", _.extend({}, Backbone.Events));
          this.set({
            webServerModel: new _webServerModel({
              eventAggregator: this.get("eventAggregator")
            })
          });

          window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);
          this.get("eventAggregator").bind("updateViews", this.updateViewsRequestedEventHandler, this);
          this.bind("change:loadedModel", this.loadConfiguration, this);

        },

        loadConfiguration: function() {
          var loadedModel = this.get("loadedModel");

          if (loadedModel.webServerModel)
            this.get("webServerModel").set("enabled", loadedModel.webServerModel.enabled);

          this.trigger("render:requested");
          this.trigger("updateViews");
        },

        updateViewsRequestedEventHandler: function() {
          this.trigger("updateViews");
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.automationRemoteControls = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.automationRemoteControls = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.automationRemoteControls = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.automationRemoteControls = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.automationRemoteControls = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.automationRemoteControls = this;
              break;
          }
          BticinoS4B.Instances.Models.ApplicationModel.set("automationRemoteControls", this);
          var toReturn = [],
            webServer = this.get("webServerModel"),
            i = 0;

          if (webServer.get("enabled")) {
            toReturn.push({
              productCode: webServer.get("productCode"),
              productLabel: webServer.get("productLabel"),
              packageClassLabel: webServer.get("packageClassLabel"),
              kitValue: webServer.get("kitValue"),
              partOfKit: webServer.get("partOfKit"),
              quantity: 1,
              price: webServer.get("price")
            });

            for (i = 0; i < webServer.get("secondaryProducts"); i++) {
              toReturn.push({
                productCode: webServer.get("secondaryProducts")[i].productCode,
                productLabel: webServer.get("secondaryProducts")[i].productLabel,
                packageClassLabel: webServer.get("secondaryProducts")[i].packageClassLabel,
                kitValue: webServer.get("secondaryProducts")[i].kitValue,
                partOfKit: webServer.get("secondaryProducts")[i].partOfKit,
                quantity: 1,
                price: webServer.get("secondaryProducts")[i].price
              });
            }

            toReturn.push({
              productCode: webServer.get("accessory").productCode,
              productLabel: webServer.get("accessory").productLabel,
              packageClassLabel: webServer.get("accessory").packageClassLabel,
              kitValue: webServer.get("accessory").kitValue,
              partOfKit: webServer.get("accessory").partOfKit,
              quantity: 1,
              price: webServer.get("accessory").price
            });
          }

          return toReturn;

        },
        resetValues: function() {
          this.set("softwareDataFetchCompleted", undefined);
          this.set("webServerDataFetchCompleted", undefined);
        },

        loadProject: function(model) {
          this.set("loadedModel", model.automationRemoteControls);
        }
      })
    });

    // Required, return the module for AMD compliance
    return automationRemoteControls;

  });